module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapterno"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('b', [_vm._v("3")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "chapter"
  }, [_vm._v("IS THE CUSTOMER ALWAYS RIGHT?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One of the worst things you can do when paying good money to hire a copywriter is to change his copy and then run it without letting him know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why is this bad?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because even a small change in the wording can significantly depress response.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have seen the change of a single word in a headline or subject line lift or lower response in an A/B test by as much as 10% to 25% — and occasionally by 50%.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On more than one occasion, clients have told me that the copy I wrote for them didn’t work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, when they send me the promotion, I see that the headline or some other key piece of the copy is not as I wrote it — almost always an unpleasant surprise for me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The client rewrote it without telling me — and then amazingly tells me that “my” copy didn’t work. Ha!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Preventing this is easy as pie.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Just send your copywriter a PDF proof of the promotion before it runs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That way, he can:")]), _vm._v(" "), _c('p', {
    staticClass: "listt"
  }, [_vm._v("1.   Check it to make sure nothing important has been altered.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("2.   Get a fresh reading and possibly suggest last-minute changes that make it even stronger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Does this mean you will never have a losing promotion again?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Any honest marketer or copywriter would tell you that a significant percentage of promotions simply do not work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But making sure any important changes are carefully reviewed and well thought through does increase the odds of having a winner in your favor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("H.G. Wells once said: “There is no greater human urge than the desire to rewrite someone else’s copy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having a client change or rewrite my copy is not a problem for me when I believe the altered version is as good as — or better — than what I had written.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When it’s not, I tell the client why I object to the revisions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But if he still wants to make the changes after hearing my reasoning, I acquiesce pleasantly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After all, it’s his money.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Questioning the work of the professional you hired is not unique to copywriting, by the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doctors, for instance, increasingly say that their patients are doing more of their own research online — and challenging the doctor’s opinions and recommendations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It seems a bit odd to me that in an era of specialization we doubt our specialists more than ever.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("The Internet may be the reason: people think they can get the same expertise their experts have just by Googling the topic, which is absurd: ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("They get the information but not the knowledge, skill, and experience in how to apply it.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Certainly, the explosion of copywriting training available — books, courses, coaching programs — has made the average consumer of copywriting services more knowledgeable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Syms, a local retailer, says “an educated consumer is our best customer.” I know I enjoy working with clients who understand what I am doing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taking the opposing point of view, JL, my gray-haired tile guy, told my wife when she suggested a change in his tiling technique: “A little knowledge is a dangerous thing.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e78d2ab4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/12_ch3.vue
// module id = 90
// module chunks = 0